import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminAuthCallback from "@/components/AdminAuthCallback";
import { SiteProvider } from "@/lib/site";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import CityService from "@/pages/CityService";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";

function AppRoutes() {
  const location = useLocation();
  // Google sign-in returns with #session_id=… — handle it before normal routing
  if (location.hash?.includes("session_id=")) return <AdminAuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/services/:slug/:city" element={<CityService />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <AppRoutes />
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-right" richColors />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
